export const _types = {
  SET_CURRENT_MODE: 'SET_CURRENT_MODE',
  SET_CURRENT_STATUS: 'SET_CURRENT_STATUS',
  SET_CURRENT_STATUS_TARGET: 'SET_CURRENT_STATUS_TARGET',
  SET_TABS_STATE: 'SET_TABS_STATE',
  SET_STATUS_TARGETS: 'SET_STATUS_TARGETS',
  SET_CURRENT_TAB: 'SET_CURRENT_TAB',
  SET_APPROVAL_NOTIFIED_INFO: 'SET_APPROVAL_NOTIFIED_INFO',
  SET_CURRENT_REQUEST_TYPE_ID: 'SET_CURRENT_REQUEST_TYPE_ID',
};
